import { useApiFileDownload } from "@skanska/vsa-client-auth";
import { ApiEndpoints } from "../models/ApiEndpoints";

export enum ReportType {
  DraftActivities,
  DraftDocuments,
  DraftLinks,
  DraftProcessImages,
  PublishedActivities,
  PublishedDocuments,
  DocumentsWithLinks,
  PublishedLinks,
  PublishedProcessImages,
}

function getReportEndpoint(reportType?: ReportType): string {
  switch (reportType) {
    case ReportType.PublishedActivities:
      return ApiEndpoints.ReportsPublishedActivities;
    case ReportType.DraftActivities:
      return ApiEndpoints.ReportsDraftActivities;
    case ReportType.PublishedDocuments:
      return ApiEndpoints.ReportsPublishedDocuments;
    case ReportType.DocumentsWithLinks:
      return ApiEndpoints.ReportsDocumentsWithLinks;
    case ReportType.DraftDocuments:
      return ApiEndpoints.ReportsDraftDocuments;
    case ReportType.PublishedLinks:
      return ApiEndpoints.ReportsPublishedLinks;
    case ReportType.DraftLinks:
      return ApiEndpoints.ReportsDraftLinks;
    case ReportType.PublishedProcessImages:
      return ApiEndpoints.ReportsPublishedActivityImages;
    case ReportType.DraftProcessImages:
      return ApiEndpoints.ReportsDraftActivityImages;
    default:
      return "";
  }
}

export function useGetReportFile(
  reportType?: ReportType,
  flat = false
): ReturnType<typeof useApiFileDownload> {
  const endpoint = getReportEndpoint(reportType);
  const result = useApiFileDownload(flat && endpoint ? `${endpoint}/flat` : endpoint, null);
  return result;
}
